import React from "react"
import { StaticQuery, graphql } from "gatsby"

import styles from './landing.module.css';
import Quote from './Quote';
import Icon from './Icon';

const Landing = ({splashText, splashQuote}) => {
  return (
    <div className="fullSection">

      <div className={styles.icon}>
        <Icon type="lightening"/>
      </div>

      <div className={styles.splashText}> Hey, I'm August. I love creating things. </div>

      <div className="whitespace"/>
    </div>
  )
}

export default Landing

